// B1 - Ünite 1: Future - Will
// Hedef: Will + fiil, offers, promises, predictions

export const B1_UNIT_1 = {
  'B1-U1-L1': {
    id: 'B1-U1-L1',
    title: 'Will + fiil (olumlu)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Will - Gelecek Zaman',
          explanation: 'Will gelecek zamanı ifade eder. Tüm şahıslarda aynı yapıda kullanılır: will + fiil',
          table: {
            headers: ['Şahıs', 'Will + Fiil', 'Örnek'],
            rows: [
              ['I', 'will + fiil', 'I will help you.'],
              ['You', 'will + fiil', 'You will enjoy the flight.'],
              ['He/She/It', 'will + fiil', 'The flight will depart at 3 PM.'],
              ['We', 'will + fiil', 'We will serve meals soon.'],
              ['They', 'will + fiil', 'They will arrive on time.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Cümle', 'Türkçesi'],
            rows: [
              ['The flight will depart at 14:30.', 'Uçuş 14:30\'da kalkacak.'],
              ['We will reach cruising altitude shortly.', 'Kısa süre içinde seyir irtifasına ulaşacağız.'],
              ['The captain will make an announcement.', 'Kaptan bir anons yapacak.'],
              ['Cabin crew will assist you.', 'Kabin ekibi size yardımcı olacak.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Will kısaltılabilir: I will = I\'ll, We will = We\'ll'
        },
        {
          type: 'vocabulary',
          title: '✈️ Will ile Anons Kelimeleri',
          words: [
            { en: 'will depart', tr: 'kalkacak', pronunciation: '' },
            { en: 'will arrive', tr: 'varacak', pronunciation: '' },
            { en: 'will land', tr: 'inecek', pronunciation: '' },
            { en: 'will serve', tr: 'servis edecek', pronunciation: '' },
            { en: 'will announce', tr: 'duyuracak', pronunciation: '' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'The flight _____ at 3 PM.',
          options: ['will depart', 'depart', 'departing', 'departs'],
          correct: 'will depart',
          explanation: 'Future: will + fiil'
        },
        {
          type: 'multipleChoice',
          question: 'We _____ meals during the flight.',
          options: ['will serve', 'serves', 'serving', 'served'],
          correct: 'will serve',
          explanation: 'Future: will + fiil'
        },
        {
          type: 'fillInBlank',
          sentence: 'The captain _____ (make) an announcement.',
          answer: 'will make',
          hint: 'Future: will + fiil'
        },
        {
          type: 'dragDrop',
          instruction: '🔀 Cümleyi doğru sıraya dizin',
          words: ['tomorrow', 'will', 'I', 'fly'],
          correctOrder: [2, 1, 3, 0],
          translation: 'Yarın uçacağım.'
        },
        {
          type: 'dragDrop',
          instruction: '🔀 Cümleyi doğru sıraya dizin',
          words: ['serve', 'We', 'will', 'meals'],
          correctOrder: [1, 2, 0, 3],
          translation: 'Yemek servis edeceğiz.'
        },
        {
          type: 'flashcard',
          title: '🎴 Will ile Kalıplar',
          cards: [
            { front: 'will depart', back: 'kalkacak' },
            { front: 'will arrive', back: 'varacak' },
            { front: 'will land', back: 'inecek' },
            { front: 'will serve', back: 'servis edecek' },
            { front: 'will announce', back: 'duyuracak' },
            { front: 'will help', back: 'yardım edecek' }
          ]
        },
        {
          type: 'timeRace',
          title: '⏱️ Will Yarışı - 60 saniyede kaç doğru?',
          cards: [
            { front: 'will fly', back: 'uçacak' },
            { front: 'will land', back: 'inecek' },
            { front: 'will take off', back: 'kalkacak' },
            { front: 'will arrive', back: 'varacak' },
            { front: 'will depart', back: 'hareket edecek' },
            { front: 'will serve', back: 'servis edecek' },
            { front: 'will help', back: 'yardım edecek' },
            { front: 'will announce', back: 'duyuracak' }
          ]
        }
      ]
    }
  },
  'B1-U1-L2': {
    id: 'B1-U1-L2',
    title: 'Won\'t + fiil (olumsuz)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Will Not = Won\'t',
          explanation: 'Olumsuz gelecek zaman: will not + fiil veya won\'t + fiil',
          table: {
            headers: ['Olumlu', 'Olumsuz', 'Kısa Form'],
            rows: [
              ['I will go.', 'I will not go.', 'I won\'t go.'],
              ['It will rain.', 'It will not rain.', 'It won\'t rain.'],
              ['We will delay.', 'We will not delay.', 'We won\'t delay.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Cümle', 'Türkçesi'],
            rows: [
              ['The flight won\'t be delayed.', 'Uçuş ertelenmeyecek.'],
              ['We won\'t have turbulence.', 'Türbülans olmayacak.'],
              ['The meal service won\'t start yet.', 'Yemek servisi henüz başlamayacak.'],
              ['Passengers won\'t need to worry.', 'Yolcuların endişelenmesi gerekmeyecek.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 won\'t = will not | Konuşmada genellikle won\'t tercih edilir.'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'The flight _____ delayed.',
          options: ['won\'t be', 'won\'t', 'will not', 'not will'],
          correct: 'won\'t be',
          explanation: 'won\'t + be (fiil)'
        },
        {
          type: 'multipleChoice',
          question: 'We _____ have any problems.',
          options: ['won\'t', 'will', 'don\'t will', 'not will'],
          correct: 'won\'t',
          explanation: 'won\'t + fiil'
        },
        {
          type: 'fillInBlank',
          sentence: 'Don\'t worry. The bag _____ (not / get) lost.',
          answer: 'won\'t get',
          hint: 'Olumsuz: won\'t + fiil'
        }
      ]
    }
  },
  'B1-U1-L3': {
    id: 'B1-U1-L3',
    title: 'Will...? (soru)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Will Soru Yapısı',
          explanation: 'Soru: Will + şahıs + fiil?',
          table: {
            headers: ['Soru', 'Cevap (+)', 'Cevap (-)'],
            rows: [
              ['Will you help me?', 'Yes, I will.', 'No, I won\'t.'],
              ['Will the flight be on time?', 'Yes, it will.', 'No, it won\'t.'],
              ['Will they serve dinner?', 'Yes, they will.', 'No, they won\'t.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '📚 WH Soruları',
          table: {
            headers: ['WH + Will', 'Örnek'],
            rows: [
              ['What will...', 'What will we have for dinner?'],
              ['When will...', 'When will we land?'],
              ['Where will...', 'Where will the bus take us?'],
              ['How long will...', 'How long will the flight be?']
            ]
          }
        },
        {
          type: 'vocabulary',
          title: '✈️ Yolcu Soruları',
          words: [
            { en: 'When will we land?', tr: 'Ne zaman ineceğiz?', pronunciation: '' },
            { en: 'Will there be turbulence?', tr: 'Türbülans olacak mı?', pronunciation: '' },
            { en: 'Will you serve coffee?', tr: 'Kahve servis edecek misiniz?', pronunciation: '' },
            { en: 'How long will the delay be?', tr: 'Gecikme ne kadar sürecek?', pronunciation: '' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '_____ the flight be on time?',
          options: ['Will', 'Do', 'Is', 'Does'],
          correct: 'Will',
          explanation: 'Soru: Will + subject + fiil?'
        },
        {
          type: 'multipleChoice',
          question: 'When _____ we land?',
          options: ['will', 'do', 'are', 'is'],
          correct: 'will',
          explanation: 'WH + will + subject + fiil'
        },
        {
          type: 'fillInBlank',
          sentence: '_____ you help me with my bag?',
          answer: 'Will',
          hint: 'Soru: Will + you + fiil?'
        }
      ]
    }
  },
  'B1-U1-L4': {
    id: 'B1-U1-L4',
    title: 'Uses: Offers, Promises, Predictions',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Will Kullanım Alanları',
          table: {
            headers: ['Kullanım', 'Örnek', 'Türkçesi'],
            rows: [
              ['Spontan Karar', 'I\'ll help you with that.', 'Sana yardım edeceğim.'],
              ['Teklif (Offer)', 'I\'ll get you some water.', 'Size biraz su getireyim.'],
              ['Söz (Promise)', 'I\'ll be careful.', 'Dikkatli olacağım.'],
              ['Tahmin (Prediction)', 'It will be a smooth flight.', 'Rahat bir uçuş olacak.'],
              ['Tehdit/Uyarı', 'If you don\'t sit, I\'ll call security.', 'Oturmazsan, güvenliği çağırırım.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılıkta Will Kullanımları',
          table: {
            headers: ['Durum', 'Cümle'],
            rows: [
              ['Teklif', 'I\'ll bring you a blanket.'],
              ['Söz', 'We\'ll do our best to make your flight comfortable.'],
              ['Tahmin', 'The weather will be good.'],
              ['Anons', 'We will begin the descent shortly.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 I\'ll = Anlık karar/teklif | I\'m going to = Önceden planlanmış'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'That bag looks heavy. I _____ help you. (teklif)',
          options: ['will', 'am going to', 'would', 'can'],
          correct: 'will',
          explanation: 'Spontan teklif = will'
        },
        {
          type: 'multipleChoice',
          question: 'I promise I _____ be late. (söz)',
          options: ['won\'t', 'don\'t', 'am not', 'will'],
          correct: 'won\'t',
          explanation: 'Söz (olumsuz) = won\'t'
        },
        {
          type: 'fillInBlank',
          sentence: 'Don\'t worry. It _____ (be) a smooth flight. (tahmin)',
          answer: 'will be',
          hint: 'Tahmin = will'
        },
        {
          type: 'matching',
          instruction: 'Will kullanımını eşleştirin',
          pairs: [
            { left: 'I\'ll get you some water.', right: 'Teklif' },
            { left: 'I\'ll never forget this.', right: 'Söz' },
            { left: 'It will rain tomorrow.', right: 'Tahmin' }
          ]
        }
      ]
    }
  },
  'B1-U1-L5': {
    id: 'B1-U1-L5',
    title: 'Uygulama: Anonslar ve Vaatler',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '✈️ Uçuş Anonsları - Will',
          table: {
            headers: ['Anons', 'Türkçesi'],
            rows: [
              ['We will be landing in approximately 30 minutes.', 'Yaklaşık 30 dakika sonra ineceğiz.'],
              ['The seatbelt sign will be turned off shortly.', 'Kemer işareti kısa süre içinde kapatılacak.'],
              ['Meal service will begin after takeoff.', 'Yemek servisi kalkıştan sonra başlayacak.'],
              ['We will experience some turbulence.', 'Biraz türbülans yaşayacağız.']
            ]
          }
        },
        {
          type: 'vocabulary',
          title: '🎤 Mülakat: Gelecek Planları',
          words: [
            { en: 'I will work hard to succeed.', tr: 'Başarı için çok çalışacağım.', pronunciation: '' },
            { en: 'I will always be professional.', tr: 'Her zaman profesyonel olacağım.', pronunciation: '' },
            { en: 'I will give my best every day.', tr: 'Her gün elimden gelenin en iyisini yapacağım.', pronunciation: '' },
            { en: 'I will learn from this experience.', tr: 'Bu deneyimden öğreneceğim.', pronunciation: '' }
          ]
        },
        {
          type: 'tip',
          content: '💡 Mülakatta "Where do you see yourself in 5 years?" sorusuna WILL ile cevap verin!'
        }
      ],
      exercises: [
        {
          type: 'speaking',
          instruction: 'Bu anonsları okuyun:',
          phrases: [
            'We will be landing in 30 minutes.',
            'The captain will make an announcement.',
            'Meal service will begin shortly.',
            'We will reach our destination on time.'
          ]
        },
        {
          type: 'fillInBlank',
          sentence: 'In 5 years, I _____ (be) a senior cabin crew member.',
          answer: 'will be',
          hint: 'Gelecek planı: will + be'
        },
        {
          type: 'multipleChoice',
          question: 'I promise I _____ always do my best.',
          options: ['will', 'am going to', 'would', 'can'],
          correct: 'will',
          explanation: 'Söz = will'
        }
      ]
    }
  },
  'B1-U1-EXAM': {
    id: 'B1-U1-EXAM',
    title: 'Ünite 1 Sınavı',
    type: 'exam',
    exercises: [
      {
        type: 'multipleChoice',
        question: 'The flight _____ at 15:00.',
        options: ['will depart', 'departs', 'departing', 'departed'],
        correct: 'will depart',
        explanation: 'Future: will + fiil'
      },
      {
        type: 'multipleChoice',
        question: 'Don\'t worry. The bag _____ lost.',
        options: ['won\'t get', 'will get', 'doesn\'t get', 'isn\'t getting'],
        correct: 'won\'t get',
        explanation: 'Olumsuz: won\'t + fiil'
      },
      {
        type: 'multipleChoice',
        question: '_____ you help me with this?',
        options: ['Will', 'Do', 'Are', 'Have'],
        correct: 'Will',
        explanation: 'Soru: Will + subject + fiil?'
      },
      {
        type: 'multipleChoice',
        question: 'That looks heavy. I _____ carry it for you. (teklif)',
        options: ['will', 'am going to', 'would', 'must'],
        correct: 'will',
        explanation: 'Spontan teklif = will'
      },
      {
        type: 'fillInBlank',
        sentence: 'We _____ (land) in approximately 30 minutes.',
        answer: 'will land',
        hint: 'Future: will + fiil'
      },
      {
        type: 'fillInBlank',
        sentence: 'I promise I _____ (not / be) late.',
        answer: 'won\'t be',
        hint: 'Söz (olumsuz): won\'t + fiil'
      }
    ]
  }
};

export default B1_UNIT_1;
